import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetAgentQuery } from "../../../../services/agentEndpoints";
import { useEffect } from "react";
import { setPageHeaderInfo } from "../../../../reducers/pagesReducer";
import { setPageError } from "../../../../reducers/rootReducer";
import { useHistory } from "react-router-dom";

/**
 * Custom hook for Page level effects for the Agent page.
 * @returns Functions and logic used by the Agent page.
 */
export const useAgentPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { agent: agentSlug } = useParams();
    const { data, error } = useGetAgentQuery({ agentSlug });
    const { pageHeaderInfo } = data || {};
    useEffect(() => {
        if (pageHeaderInfo) {
            dispatch(setPageHeaderInfo(pageHeaderInfo));
        }
    }, [pageHeaderInfo, dispatch]);

    if (error) {
        if (
            error?.status === 400 &&
            error?.data?.message?.agentId.includes("Inactive")
        ) {
            history.replace(`/agents`);
        } else {
            dispatch(
                setPageError({
                    page: "Agent",
                    error: "Error loading agent page.",
                })
            );
        }
    }
};
